var map = {
	"./amaze.png": 39628,
	"./angel.png": 34590,
	"./angry.png": 35045,
	"./applause.png": 96896,
	"./arrogant.png": 79909,
	"./astonished.png": 2918,
	"./awkward.png": 64621,
	"./bigcry.png": 80570,
	"./blessing.png": 60709,
	"./boo.png": 6281,
	"./bye.png": 58678,
	"./candle.png": 32406,
	"./cheer.png": 31116,
	"./comic.png": 72284,
	"./cool.png": 34571,
	"./crazy.png": 99111,
	"./cry.png": 38950,
	"./cute.png": 11679,
	"./daze.png": 36846,
	"./dignose.png": 49203,
	"./dizzy.png": 86990,
	"./dog.png": 35477,
	"./dontbicker.png": 39652,
	"./doubt.png": 70363,
	"./drinktea.png": 12412,
	"./dung.png": 59164,
	"./embrace.png": 24864,
	"./evil.png": 7476,
	"./facepalmcry.png": 11573,
	"./fallill.png": 31969,
	"./follow.png": 64458,
	"./frown.png": 32403,
	"./handshake.png": 75867,
	"./hard.png": 5260,
	"./heart.png": 39678,
	"./hehe.png": 52726,
	"./kiss.png": 6425,
	"./kneel.png": 73289,
	"./kneelcry.png": 79780,
	"./laughcry.png": 5778,
	"./lechery.png": 63419,
	"./letgo.png": 79955,
	"./like.png": 43329,
	"./majestic.png": 6598,
	"./ok.png": 79309,
	"./pathetic.png": 12299,
	"./praise.png": 45203,
	"./reversesmile.png": 25974,
	"./rose.png": 88475,
	"./shutup.png": 70524,
	"./shy.png": 75854,
	"./simper.png": 32562,
	"./slap.png": 72100,
	"./sleep.png": 65357,
	"./sleepy.png": 13937,
	"./smile.png": 15196,
	"./snap.png": 13342,
	"./split.png": 69911,
	"./stoptalking.png": 76449,
	"./struggle.png": 42734,
	"./sweat.png": 23487,
	"./teethlaugh.png": 88880,
	"./titter.png": 97375,
	"./vomit.png": 19186,
	"./wane.png": 5192,
	"./watermelon.png": 65694
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96504;